import { StrictMode, createElement } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const redirectToHttps = () => {
  if (typeof window === 'undefined') return;

  const { protocol, hostname } = window.location;
  const localhostHosts = ['localhost', '127.0.0.1', '::1'];

  if (protocol !== 'http:' || localhostHosts.includes(hostname)) {
    return;
  }

  const targetUrl = new URL(window.location.href);
  targetUrl.protocol = 'https:';
  window.location.replace(targetUrl.toString());
};

const redirectFromStaticFallback = () => {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const redirectPath = params.get('redirect');

  if (!redirectPath) return;

  const targetUrl = new URL(redirectPath, window.location.origin);
  if (targetUrl.origin !== window.location.origin) return;

  window.history.replaceState({}, '', targetUrl.pathname + targetUrl.search + targetUrl.hash);
};

redirectToHttps();
redirectFromStaticFallback();

createRoot(document.getElementById('root')!).render(
  createElement(StrictMode, null, createElement(App))
);
